
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.558 14.025l-1.725-1.767A2.566 2.566 0 0013 11.783l-.75-.75a5.833 5.833 0 10-1.175 1.175l.742.742a2.5 2.5 0 00.441 2.883l1.767 1.767a2.5 2.5 0 003.533 0 2.498 2.498 0 000-3.575zm-7.066-3.533a4.166 4.166 0 11-5.885-5.9 4.166 4.166 0 015.885 5.9zm5.891 5.891a.833.833 0 01-1.183 0l-1.767-1.766a.833.833 0 010-1.184.834.834 0 011.184 0l1.766 1.767a.832.832 0 010 1.183z","fill":"currentColor"}})])
          )
        }
      }
    